import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import logo from '../assets/logo_oficina.png';
import { FaBars, FaTimes } from 'react-icons/fa';

const Nav = styled.nav`
  background: ${({ scrollNav }) => (scrollNav ? '#4F4C4C' : 'transparent')};
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: 0.8s all ease;
`;

const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;

const NavLogo = styled(Link)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;

  img {
    height: 60px;
  }
`;

const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 80px;
    left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    opacity: 1;
    transition: all 0.5s ease;
    background: #4F4C4C;
  }
`;

const NavItem = styled.li`
  height: 80px;
`;

const NavLinks = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 500;

  &.active {
    border-bottom: 3px solid #c77408;
  }

  &:hover {
    color: #c77408;
    transition: 0.2s ease-in-out;
  }
`;


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrollNav, setScrollNav] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  return (
    <Nav scrollNav={scrollNav}>
      <NavbarContainer>
        <NavLogo to="hero" smooth={true} duration={500} spy={true} exact='true'>
          <img src={logo} alt="Primeira Linha Logo" />
        </NavLogo>
        <MobileIcon onClick={toggle}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </MobileIcon>
        <NavMenu isOpen={isOpen} onClick={toggle}>
          <NavItem>
            <NavLinks to="about" smooth={true} duration={500} spy={true} exact='true'>Sobre</NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to="services" smooth={true} duration={500} spy={true} exact='true'>Serviços</NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to="location" smooth={true} duration={500} spy={true} exact='true'>Localização</NavLinks>
          </NavItem>
          <NavItem>
            <a href="https://api.whatsapp.com/send?phone=556232843050" target="_blank" rel="noopener noreferrer" style={{color: '#fff', padding: '0 1rem', display: 'flex', alignItems: 'center', height: '100%', fontWeight: '500', background: '#c77408', marginLeft: '1rem' }}>
              Fale Conosco
            </a>
          </NavItem>
        </NavMenu>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;